/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DropboxersResponse } from '../models/DropboxersResponse';
import type { FeedbackResponse } from '../models/FeedbackResponse';
import type { OptOutFeaturesRequest } from '../models/OptOutFeaturesRequest';
import type { OptOutFeaturesResponse } from '../models/OptOutFeaturesResponse';
import type { ReportsResponse } from '../models/ReportsResponse';
import type { ReviewCyclesResponse } from '../models/ReviewCyclesResponse';
import type { ReviewResponse } from '../models/ReviewResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class DropboxerService {

    /**
     * Refresh All Dropboxers
     * Refreshes all dropboxers in the database with the latest data from Workday
     * @returns any Successful Response
     * @throws ApiError
     */
    public static refreshAllDropboxersApiV1DropboxerRefreshPut(
        environment: 'prod' | 'sandbox' | 'both' = 'both',
        dryRun: boolean = false,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/dropboxer/refresh',
            query: {
                'environment': environment,
                'dry_run': dryRun,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Refresh All Feedback
     * Refreshes all feedback in the database with the latest data from Workday
     * @returns any Successful Response
     * @throws ApiError
     */
    public static refreshAllFeedbackApiV1DropboxerRefreshFeedbackPut(
        environment: 'prod' | 'sandbox' | 'both' = 'both',
        dryRun: boolean = false,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/dropboxer/refresh/feedback',
            query: {
                'environment': environment,
                'dry_run': dryRun,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Refresh All Reviews
     * Refreshes all reviews in the database with the latest data from Workday
     * @returns any Successful Response
     * @throws ApiError
     */
    public static refreshAllReviewsApiV1DropboxerRefreshReviewsPut(
        environment: 'prod' | 'sandbox' | 'both' = 'both',
        dryRun: boolean = false,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/dropboxer/refresh/reviews',
            query: {
                'environment': environment,
                'dry_run': dryRun,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Refresh All Review Cycles
     * Refreshes review cycle metadata in the database with the latest data from Workday
     * @returns any Successful Response
     * @throws ApiError
     */
    public static refreshAllReviewCyclesApiV1DropboxerRefreshReviewCyclesPut(
        environment: 'prod' | 'sandbox' | 'both' = 'both',
        dryRun: boolean = false,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/dropboxer/refresh/review-cycles',
            query: {
                'environment': environment,
                'dry_run': dryRun,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Refresh All Feedback Requests
     * Refreshes feedback request data in the database with the latest data from Workday
     * @returns any Successful Response
     * @throws ApiError
     */
    public static refreshAllFeedbackRequestsApiV1DropboxerRefreshFeedbackRequestsPut(
        environment: 'prod' | 'sandbox' | 'both' = 'both',
        dryRun: boolean = false,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/dropboxer/refresh/feedback-requests',
            query: {
                'environment': environment,
                'dry_run': dryRun,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get All Dropboxers
     * Returns all dropboxers in the database
     * @param isSandbox
     * @returns DropboxersResponse Successful Response
     * @throws ApiError
     */
    public static getAllDropboxersApiV1DropboxerAllGet(
        isSandbox: boolean = false,
    ): CancelablePromise<DropboxersResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/dropboxer/all',
            query: {
                'is_sandbox': isSandbox,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Search Dropboxer By Name Or Email
     * Returns a list of dropboxers that match the given name or email
     * @param name
     * @param limit
     * @param isSandbox
     * @returns DropboxersResponse Successful Response
     * @throws ApiError
     */
    public static searchDropboxerByNameOrEmailApiV1DropboxerSearchGet(
        name: string,
        limit: number = 3,
        isSandbox: boolean = false,
    ): CancelablePromise<DropboxersResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/dropboxer/search',
            query: {
                'name': name,
                'limit': limit,
                'is_sandbox': isSandbox,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Search Reports By Name Or Email
     * Searches for all hierarchical reports of the current user or the given employee by name or email
     * @param employeeId If provided, will search within the reports of this employee
     * @param name The name or email to search for
     * @param limit The maximum number of results to return
     * @param isSandbox
     * @returns DropboxersResponse Successful Response
     * @throws ApiError
     */
    public static searchReportsByNameOrEmailApiV1DropboxerSearchReportsGet(
        employeeId?: (string | null),
        name: string = '',
        limit: number = 3,
        isSandbox: boolean = false,
    ): CancelablePromise<DropboxersResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/dropboxer/search_reports',
            query: {
                'employee_id': employeeId,
                'name': name,
                'limit': limit,
                'is_sandbox': isSandbox,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Reports
     * Returns the direct and indirect reports of the current user or the given employee
     * @param employeeId
     * @param isSandbox
     * @returns ReportsResponse Successful Response
     * @throws ApiError
     */
    public static getReportsApiV1DropboxerGetReportsGet(
        employeeId?: (string | null),
        isSandbox: boolean = false,
    ): CancelablePromise<ReportsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/dropboxer/get_reports/',
            query: {
                'employee_id': employeeId,
                'is_sandbox': isSandbox,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Feedback
     * Returns the feedback for a given employee. Will error if current user is
     * not a manager of the given employee, self, or a superuser.
     * @param employeeId
     * @param isSandbox
     * @returns FeedbackResponse Successful Response
     * @throws ApiError
     */
    public static getFeedbackApiV1DropboxerFeedbackEmployeeIdGet(
        employeeId: string,
        isSandbox: boolean = false,
    ): CancelablePromise<FeedbackResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/dropboxer/feedback/{employee_id}',
            path: {
                'employee_id': employeeId,
            },
            query: {
                'is_sandbox': isSandbox,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Reviews
     * Returns the reviews for a given employee. Will error if current user is
     * not a manager of the given employee, self, or a superuser.
     * @param employeeId
     * @param isSandbox
     * @returns ReviewResponse Successful Response
     * @throws ApiError
     */
    public static getReviewsApiV1DropboxerReviewsEmployeeIdGet(
        employeeId: string,
        isSandbox: boolean = false,
    ): CancelablePromise<ReviewResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/dropboxer/reviews/{employee_id}',
            path: {
                'employee_id': employeeId,
            },
            query: {
                'is_sandbox': isSandbox,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Privacy Policies
     * Get all the privacy policies for a user
     * @param isSandbox
     * @returns OptOutFeaturesResponse Successful Response
     * @throws ApiError
     */
    public static getPrivacyPoliciesApiV1PrivacyGet(
        isSandbox: boolean = false,
    ): CancelablePromise<OptOutFeaturesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/privacy',
            query: {
                'is_sandbox': isSandbox,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Set Privacy Policies
     * Set privacy policies for a user
     * @param requestBody
     * @param isSandbox
     * @returns OptOutFeaturesResponse Successful Response
     * @throws ApiError
     */
    public static setPrivacyPoliciesApiV1PrivacyPost(
        requestBody: OptOutFeaturesRequest,
        isSandbox: boolean = false,
    ): CancelablePromise<OptOutFeaturesResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/privacy',
            query: {
                'is_sandbox': isSandbox,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Review Cycles
     * Returns all review cycles. In sandbox mode, reads from the DB.
     * In prod mode, returns hardcoded fallback data.
     * @param isSandbox
     * @returns ReviewCyclesResponse Successful Response
     * @throws ApiError
     */
    public static getReviewCyclesApiV1ReviewCyclesGet(
        isSandbox: boolean = false,
    ): CancelablePromise<ReviewCyclesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/review-cycles',
            query: {
                'is_sandbox': isSandbox,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

}
